import React from 'react'
import { useAxios } from '../hooks/useAxios'
import { getNotifications } from '../api/getNotifications'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'
import Card from '../components/Card'
import { Notification } from '../server/notifications/list/get'
import Btn from '../components/Btn'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { checkNotification } from '../api/checkNotification'
import { NotificationsStore } from '../store/notificationsStore'

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Уведомления',
    path: '/notifications'
  }
]

const NotificationsPage: React.FC = () => {
  const {
    response: notifications,
    loading: notificationsLoading,
    error: notificationsError,
    fire: notificationsFire
  } = useAxios()
  const { fire } = useAxios()
  const { portal } = usePortal()
  const elRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    notificationsFire(getNotifications()).then(() => {
      setTimeout(() => {
        const el = elRef.current
        if (el && el.children.length) {
          Array.from(el.children)
            .filter((i) => {
              return i.hasAttribute('data-id')
            })
            .forEach((i) => {
              ScrollTrigger.create({
                trigger: i,
                start: 'center bottom',
                once: true,
                onEnter: async (self) => {
                  const id = i.getAttribute('data-id')
                  if (id) {
                    const { error } = await fire(checkNotification(id))

                    if (!error) {
                      NotificationsStore.reduceCount()
                    }
                  }
                }
              })
            })
        }
      })
    })
  }, [])

  return (
    <div className="page">
      <Breadcrumbs className={'page__breadcrumbs'} breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={BREADCRUMBS}></Breadcrumbs>,
          portal
        )}

      <header className="page__head">
        <h1>Уведомления</h1>
      </header>

      <div ref={elRef} className="page__content">
        {notificationsLoading || !notificationsError ? (
          <>
            {notificationsLoading ? (
              <>
                {Array.from({ length: 3 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    className={classNames({ 'mt-md-5 mt-sm-4': !!i })}
                    height={'14rem'}
                    style={{ maxWidth: '74rem' }}
                    borderRadius={'3.2rem'}
                  ></Skeleton>
                ))}
              </>
            ) : notifications?.data?.length ? (
              <>
                {notifications.data.map(
                  (notification: Notification, i: number) => (
                    <Card
                      data-id={notification.isNew ? notification.id : undefined}
                      style={{ maxWidth: '74rem' }}
                      tag={'article'}
                      key={notification.id}
                      className={classNames('notification-card', {
                        'mt-md-5 mt-sm-4': !!i
                      })}
                    >
                      {notification.title && (
                        <h2 className={'text-h4'}>{notification.title}</h2>
                      )}
                      {notification.text && (
                        <p
                          className={classNames(
                            'text-body-small text-secondary-color',
                            { 'mt-md-4 mt-sm-3': notification.title }
                          )}
                        >
                          {notification.text}
                        </p>
                      )}
                      {notification.link && (
                        <>
                          {!notification.linkIsExternal ? (
                            <Btn
                              to={notification.link}
                              className={'mt-md-8 mt-sm-6'}
                            >
                              {notification.linkText ?? 'Перейти'}
                            </Btn>
                          ) : (
                            <Btn
                              href={notification.link}
                              className={'mt-md-8 mt-sm-6'}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {notification.linkText ?? 'Перейти'}
                            </Btn>
                          )}
                        </>
                      )}
                    </Card>
                  )
                )}
              </>
            ) : (
              <p>Нет уведомлений</p>
            )}
          </>
        ) : (
          <p>{notificationsError.message}</p>
        )}
      </div>
    </div>
  )
}

export default NotificationsPage
